import React from "react";
import './LeftParagraph.css' 


export default props => (
  <div className="left-paragraph">
    {props.block.text}
  </div>
);
